// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1LuWB","additionalInfo":"AgreementModal_additionalInfo__25LvW"};